import useIndividualExposures, {
  type IndividualExposureFund,
  type IndividualExposureSchema
} from '../../../hooks/useIndividualExposures';
import { Table } from '../../Table';
import React from 'react';
import { TableSubTitle, TableTitle, TableStyle } from './style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

export function IndividualExposures({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps<
  Record<string, IndividualExposureFund>,
  Record<'INDIVIDUAL_EXPOSURES', IndividualExposureSchema>
>) {
  const { onChange: onChange, tables } = useIndividualExposures({
    data: funds[currentDataKey]?.fund_data.INDIVIDUAL_EXPOSURES,
    onChangeFund,
    schema: schema.INDIVIDUAL_EXPOSURES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.INDIVIDUAL_EXPOSURES?.field_names || [],
    funds,
    isMultiFunds
  });

  return tables.map((item, index) => (
    <React.Fragment key={`${item.name}-${index}`}>
      <TableTitle id={`fca-reporttables-individual-exposures-title-${idCreator(item.name)}`}>
        {item.name}:
      </TableTitle>
      {item.tables.map((value, j) => (
        <React.Fragment key={`${value.name}-${j}-${index}`}>
          <TableSubTitle
            id={`fca-reporttables-individual-exposures-subtitle-${idCreator(value.name)}`}
          >
            {value.name}
          </TableSubTitle>
          <TableStyle id={`fca-reporttables-individual-exposures-group-${idCreator(value.name)}`}>
            {value.tables.map((table, i) => (
              <div
                className="table-item"
                id={`fca-reporttables-individual-exposures-item-${idCreator(value.name)}-${i + 1}`}
                key={`table-item-${i}-${j}-${index}`}
              >
                <Table
                  id={`fca-reporttables-individual-exposures-table-${idCreator(value.name)}-${i + 1}`}
                  handleChanges={onChange}
                  columns={table.columns}
                  rows={table.rows}
                  stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
                />
              </div>
            ))}
          </TableStyle>
        </React.Fragment>
      ))}
    </React.Fragment>
  ));
}
